'use strict';

import paginationTemplate from './pagination.directive.html';

export default angular
  .module('maestro.directives.components.pagination', [])

  .directive('pagination', function() {
    return {
      restrict: 'E',
      template: paginationTemplate,
      scope: {
        page: '=',
        totalPages: '<',
        totalItems: '=',
        onPageChange: '&',
        moreItems: '='
      },
      controller: $scope => {
        $scope.$watch('page', () => {
          initPagination();
        });
        $scope.$watch('totalPages', () => {
          initPagination();
        });

        function initPagination() {
          $scope.paginationPages = [];
          if (!$scope.page || !$scope.totalPages || $scope.page <= 0 || $scope.totalPages <= 0 || $scope.page > $scope.totalPages) {
            return;
          }
          for (let i = 1; i <= $scope.totalPages; i++) {
            let isDisabled = i !== 1 && i !== $scope.totalPages && Math.abs($scope.page - i) > 2;
            if (isDisabled &&
              $scope.paginationPages[$scope.paginationPages.length - 1] &&
              $scope.paginationPages[$scope.paginationPages.length - 1].disabled) {
              continue;
            }
            $scope.paginationPages.push({
              number: isDisabled ? void 0 : i,
              disabled: isDisabled,
              active: $scope.page === i
            });
          }
        }

        $scope.goToPage = (page) => {
          if (!page || $scope.page === page) {
            return;
          }
          // Scroll to top
          $(document).scrollTop(0);
          return $scope.onPageChange({ page: page });
        };
      }
    };
  })

  .name;
